const EMPTY_TEXT = '<p class="md-block-unstyled"><br/></p>';

const selectLanguage = ({ text, language }) => {
  if (!text) {
    return "";
  }
  if (text[language]) {
    return text[language];
  }
  // fallback language
  else if (text["en"]) {
    return text["en"];
  } else if (text["fr"]) {
    return text["fr"];
  }
  // the only language
  if (Object.values(text)[0]) {
    return Object.values(text)[0];
  }
};

export default selectLanguage;
